import actions from "./actions";

const initialState = {
  firstName: "",
  lastName: "",
  fullName: "",
  username: "",
  name: "",
  role: "",
  email: "",
  phoneNumber: "",
  mfaPhoneNumber: "",
  authorized: process.env.REACT_APP_AUTHENTICATED || false, // false is default value
  avatar: "",
  id: "",
  loading: false,
  emailVerified: false,
  users: [],
  // Redux's own documented pattern for async fetch state (see Redux's
  // "Async Actions" guide / Style Guide's status-enum recommendation) -
  // not a boolean. A boolean can't represent "a fetch is currently in
  // flight," which is exactly the case that needs guarding against for
  // the app-wide directory fetch in Layout/index.js - two fetches could
  // otherwise both start before either resolves.
  usersStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  usersError: null,
  dentalTeamAdmin: [
    "68Ov2zluO9VqSedTVMl1h4diL6H2",
    "w46hOcKzRIYJoR8kw5kYIazPAwX2",
    "9nJXkqfwnDROHyohQFX0HUHBF1V2",
    "DjaDy2p5D2dksOOE8weLMhTr3tb2",
  ],
  developers: [
    "v1YF4orXH2hP8yuE9pjnpAMHdBm2"
  ],
  preferredClinic: ""
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    // Three-action request lifecycle for the app-wide directory fetch
    // (Layout/index.js) - REQUEST/SUCCESS/FAILURE, matching Redux's own
    // documented "Async Actions" pattern (dispatch a REQUEST action before
    // the async call, then SUCCESS or FAILURE after), rather than a
    // single success-only action that can't represent an in-flight or
    // failed fetch. Raw string literals (not imported from ./actions) -
    // same convention UserList's own dispatch already uses
    case "user/FETCH_USERS_REQUEST": {
      return { ...state, usersStatus: 'loading', usersError: null }
    }
    case "user/FETCH_USERS_SUCCESS": {
      return { ...state, users: action.payload, usersStatus: 'succeeded' }
    }
    case "user/FETCH_USERS_FAILURE": {
      return { ...state, usersStatus: 'failed', usersError: action.payload }
    }
    case actions.ADD_USER: {
      const { firstName, lastName } = action.payload
      const updatedUsersList = state.users
        .concat({
          ...action.payload,
          fullName: `${firstName} ${lastName}`
        })
      const copy = { ...state, users: [...updatedUsersList] }
      return { ...state, ...copy }
    }
    case actions.EDIT_USER: {
      let updatedUsersList;
      let copy = {};

      if (state.id === action.payload.id) {
        updatedUsersList = 

        copy = { ...state, ...action.payload.updates }
      } else {
        updatedUsersList = state.users
          .map(singleUser => {
            if (singleUser.id === action.payload.id) {
  
              return {
                ...singleUser,
                ...action.payload.updates,
              }
            }
  
            return singleUser
          })

        copy = { ...state, users: [...updatedUsersList] }
      }

      return { ...state, ...copy }
    }
    case actions.EDIT_PREFERRED_CLINIC: {
      const { preferredClinic } = action.payload
      const copy = { ...state, preferredClinic };
      return { ...state, ...copy }
    }
    case actions.VERIFY_EMAIL: {
      const { email } = action.payload;
      const copy = { ...state, email };
      return { ...state, ...copy }
    }
    default:
      return state;
  }
}
